import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";

const ProductMatrixAddModal = React.forwardRef((props, ref) => {

  const activeOptions = [
    { id: 1, name: "Yes", textField: "type" },
    { id: 2, name: "No", textField: "type" },
  ]


  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },

    {
      name: "Type",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="type"
          placeholder=""
          value={row.type || ""}
          onChange={(event) => handleInputChange(row.id, "type", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Account Code",
      selector: (row) => row.accountcode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="accountcode"
          placeholder=""
          value={row.accountcode || ""}
          onChange={(event) => handleInputChange(row.id, "accountcode", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Account Relation",
      selector: (row) => row.accountRelation || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="accountRelation"
          placeholder=""
          value={row.accountRelation || ""}
          // onChange={(event) => handleInputChange(row.accountRelation, event, "Number")}
          onChange={(event) => handleInputChange(row.id, "accountRelation", event.target.value)}

        // disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          placeholder=""
          value={row.itemCode || ""}
          onChange={(event) => handleInputChange(row.id, "itemCode", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Reation",
      selector: (row) => row.itemRelation || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemRelation"
          placeholder=""
          value={row.itemRelation || ""}
          onChange={(event) => handleInputChange(row.id, "itemRelation", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Instruction",
      selector: (row) => row.instruction || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="instruction"
          placeholder=""
          value={row.instruction || ""}
          onChange={(event) => handleInputChange(row.id, "instruction", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="description"
          placeholder=""
          value={row.description || ""}
          onChange={(event) => handleInputChange(row.id, "description", event.target.value)}
          disabled={false}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => deleteProductDetails(row.id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);

  // const [isCardVisible4, setCardVisible4] = useState(true);
  // const [isCardVisible7, setCardVisible7] = useState(true);

  // const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal] = useState(false);

  const [getErrorFields, /*setErrorFields*/] = useState([]);
  // const [/*getcontactPosition*/, setcontactPosition] = useState([]);
  // const [/*getTitle*/, setTitle] = useState([]);

  // const [/*getdocumentType*/, setdocumentType] = useState([]);

  // const [/*getState*/, setState] = useState([]);
  // const [/*getCountry*/, setCountry] = useState([]);

  //productDetailsData



  const [validation, setValidation] = useState({
    driverName: "",
  });


  // const [getProjectDetails, setProjectDetails] = useState([newProject]);

  //bank state


  // const [/*getCompanyCode*/, setCompanyCode] = useState([]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    // createdBy: userData?.userId || "",
    identification: "",
    itemNumber: "",
    product: "",
    productType: "",
    productSubType: "",
    retailCategory: "",
    porductBrands: "",
    purchase: "",
    inventory: "",
    sales: "",
    recomended: "",

  });
  const [disabled, /*setDisabled*/] = useState(false);
  // console.log(">>formInputs", formInputs);
  // useEffect(() => {
  //   // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
  //   getMasterData();
  // }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // console.log(">> formInputs", formInputs);

  // SAVE
  const handleSave = async () => {
    // const requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    // if (!validateRequired(formInputs.driverName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     driverName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address2)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address2: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.city)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     city: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cityPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.companyCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     companyCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.distance)) {
    //   requiredFields.push(`${message.GET_MAP_DISTANCE}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   // setValidation((prev) => ({
    //   //   ...prev,
    //   //   cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   // }));
    //   return;
    // }
    // if (!validateRequired(formInputs.salesOfficerName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     salesOfficerName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.routeNumber)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     routeNumber: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    formInputs.productDetails = getProductDetailsData;


    const obj = {
      data: formInputs,
    };
    console.log(">>obj", obj);
    // setDisabled(true);
    // await logistics.addDriverMaster(obj).then((item) => {
    //   // console.log('>> item!',item);
    //   if (item?.status === 200) {
    //     toast.success(item?.message || "added successfully", {
    //       duration: 2000,
    //       position: "top-right",
    //     });

    //     // dispatch(saveCustomerRegData(item?.data));
    //   navigate(LogisticsConstants.LOGISTICS_MASTER_DRIVER_LIST);

    //     // console.log(">> userData");

    //     } else {
    //     // setErrorMsg('*'+ item?.message);
    //     toast.error(item?.message || "Please try again !!", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //   }
    //   setDisabled(false);
    // });
  };

  //Load Master Data
  // const getMasterData = async () => {
  //   let obj = {
  //     codeType: "title",
  //   };
  //   await ItemService.getMasterDataSelf(obj).then((item) => {
  //     // console.log(">> item! title", item);
  //     if (item?.status === 200) {
  //       setTitle(item?.data);
  //     } else {
  //       setTitle([]);
  //       console.log(">> Error: Loading getMasterDataSelf");
  //     }
  //   });

  //   let obj1 = {
  //     codeType: "documentType",
  //   };
  //   await ItemService.getMasterDataSelf(obj1).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setdocumentType(item?.data);
  //     } else {
  //       setdocumentType([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });

  //   let obj2 = {
  //     codeType: "jobtitle",
  //   };
  //   await ItemService.getMasterDataSelf(obj2).then((item) => {
  //     // console.log(">> item!", item);
  //     if (item?.status === 200) {
  //       setcontactPosition(item?.data);
  //     } else {
  //       setcontactPosition([]);
  //       console.log(">> Error: Loading getMasterDataSelf");
  //     }
  //   });

  //   let obj3 = {
  //     codeType: "country",
  //   };
  //   await ItemService.getMasterDataSelf(obj3).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setCountry(item?.data);
  //     } else {
  //       setCountry([]);
  //       console.log(">> Error: Loading getMasterDataSelf");
  //     }
  //   });
  //   let obj4 = {
  //     codeType: "companyCode",
  //   };
  //   await ItemService.getMasterData(obj4).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setCompanyCode(item?.data);
  //     } else {
  //       setCompanyCode([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  // };
  // // Onselect of Country state will load
  // const getStateData = async (code) => {
  //   let obj1 = {
  //     codeType: "region",
  //     code: code,
  //   };
  //   await ItemService.getMasterDataSelf(obj1).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setState(item?.data);
  //     } else {
  //       setState([]);
  //       console.log(">> Error: Loading getMasterDataSelf");
  //     }
  //   });
  // };

  // const hideFailureModal = () => {
  //   setShowFailureModal(false);
  // };
  /* --------------------- product details block-------- */
  const [getProductDetailsData, setProductDetailsData] = useState([
    {
      id: 1,
      local_id: 1,
      type: "",
      accountcode: "",
      accountRelation: "",
      itemCode: "",
      itemRelation: "",
      instruction: "",
      description: "",
    },
  ]);
  const addProductDetail = () => {
    const newId = Date.now();
    const newRow = {
      id: newId,
      local_id: getProductDetailsData.length + 1,
      type: "",
      accountcode: "",
      accountRelation: "",
      itemCode: "",
      itemRelation: "",
      instruction: "",
      description: "",
    };
    setProductDetailsData([...getProductDetailsData, newRow]);
  };
  const deleteProductDetails = (idToDelete) => {
    const updatedData = getProductDetailsData.filter((item) => item.id !== idToDelete);
    setProductDetailsData(updatedData);
  };
  const handleInputChange = (id, field, value) => {
    const updatedData = getProductDetailsData.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setProductDetailsData(updatedData);
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [ getFileViewData,setFileViewData] = useState(null);

const handleViewFile = (fileAttachmentId) => {
  setFileViewData(fileAttachmentId);
  setShowFileViewModal(true);
};
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const onSuccessUploadfiles = (data) => {
    setFormInputs((prevData) => ({
      ...prevData,
      [data.fieldName]: data.attachmentId,
    }));
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Product
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">

        <Row className="mb-4">
          <Col
            xs={12}
            md={{ span: 2, offset: 10 }}
            lg={{ span: 2, offset: 10 }}
            className="text-left"
          >
            <button
              className="btnTable"
              onClick={handleSave}
              disabled={disabled}
            >
              <i className="bi bi-save"></i> Create
            </button>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12}>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">320102: Casualpolo </span>
                      <span className="subHeaderTitle">Product Matrix - Product 320102 - Casual Polo(View)</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Identification"
                          name="identification"
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          placeholder=""
                          value={formInputs.identification || ""}
                          onChange={onInputChange}
                          error={validation.identification}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      {formInputs.identification === "Yes" && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Item Number"
                              name="itemNumber"
                              placeholder=""
                              value={formInputs.itemNumber || ""}
                              onChange={onInputChange}
                              error={validation.itemNumber}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Product"
                              name="product"
                              placeholder=""
                              value={formInputs.product || ""}
                              onChange={onInputChange}
                              error={validation.product}
                              required={true}
                            />
                          </Col>

                        </>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Type"
                          name="productType"
                          placeholder=""
                          value={formInputs.productType || ""}
                          onChange={onInputChange}
                          error={validation.productType}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Subtype "
                          name="productSubType"
                          placeholder=""
                          value={formInputs.productSubType || ""}
                          onChange={onInputChange}
                          error={validation.productSubType}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Retail Category"
                          name="retailCategory"
                          placeholder="Name"
                          value={formInputs.retailCategory || ""}
                          onChange={onInputChange}
                          error={validation.retailCategory}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Brands"
                          name="porductBrands"
                          placeholder="Brand"
                          value={formInputs.porductBrands || ""}
                          onChange={onInputChange}
                          error={validation.porductBrands}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Prices</span>
                      <span className="subHeaderTitle">Prices</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase"
                          name="purchase"
                          placeholder=""
                          value={formInputs.purchase || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.purchase}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inventory"
                          name="inventory"
                          placeholder=""
                          value={formInputs.inventory || ""}
                          onChange={onInputChange}
                          error={validation.inventory}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sales "
                          name="sales"
                          placeholder=""
                          value={formInputs.sales || ""}
                          onChange={onInputChange}
                          error={validation.sales}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Recomended "
                          name="recomended"
                          placeholder=""
                          value={formInputs.recomended || ""}
                          onChange={onInputChange}
                          error={validation.recomended}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion sri-venkateshwara mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Product Details</span>
                        <span className="subHeaderTitle">Product Details</span>
                      </Col>
                      <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                        <button className="btnTable" onClick={addProductDetail}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={productDetailsCol}
                            data={getProductDetailsData}
                            pagination

                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            {/* Wash & Care */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">WC</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Wash and Care</span>
                      <span className="subHeaderTitle">Wash and Care</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Temperature"
                          name="temperature"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.temperature || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.temperature}
                        />
                      </Col>
                      {formInputs.temperature === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="temperatureDescription"
                            placeholder="description"
                            value={formInputs.temperatureDescription || ""}
                            onChange={onInputChange}
                            error={validation.temperatureDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Bleach"
                          name="bleach"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.bleach || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.bleach}
                        />
                      </Col>
                      {formInputs.bleach === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="bleachDescription"
                            placeholder="description"
                            value={formInputs.bleachDescription || ""}
                            onChange={onInputChange}
                            error={validation.bleachDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Tumble Dry"
                          name="tumbleDry"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.tumbleDry || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.tumbleDry}
                        />
                      </Col>
                      {formInputs.tumbleDry === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="tumbleDryDescription"
                            placeholder="description"
                            value={formInputs.tumbleDryDescription || ""}
                            onChange={onInputChange}
                            error={validation.tumbleDryDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Iron"
                          name="iron"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.iron || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.iron}
                        />
                      </Col>
                      {formInputs.iron === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="ironDescription"
                            placeholder="description"
                            value={formInputs.ironDescription || ""}
                            onChange={onInputChange}
                            error={validation.ironDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Dry Clean"
                          name="dryClean"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.dryClean || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.dryClean}
                        />
                      </Col>
                      {formInputs.dryClean === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="dryCleanDescription"
                            placeholder="description"
                            value={formInputs.dryCleanDescription || ""}
                            onChange={onInputChange}
                            error={validation.dryCleanDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Generic"
                          name="generic"
                          placeholder=""
                          iconClassName="dropdownIcon"
                          data={activeOptions}
                          value={formInputs.generic || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          error={validation.generic}
                        />
                      </Col>
                      {formInputs.generic === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="genericDescription"
                            placeholder="genericDescription"
                            value={formInputs.genericDescription || ""}
                            onChange={onInputChange}
                            error={validation.genericDescription}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          name="productAttachment"
                          label="Product Attachment?"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true}
                          onSuccessUpload={onSuccessUploadfiles}
                          value={formInputs.productAttachment || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                      >
                        {(formInputs?.productAttachment && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(
                                formInputs?.productAttachment
                              )
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

          </Col>
        </Row>
        {/* </div>
        </Col>
      </Row> */}

        <Row className="mb-4">
          <Col
            xs={12}
            md={{ span: 2, offset: 10 }}
            lg={{ span: 2, offset: 10 }}
            className="text-left"
          >
            <button className="btnTable" onClick={handleSave} disabled={disabled}>
              <i className="bi bi-save"></i> Create
            </button>
          </Col>
        </Row>

        <FailureModal
          show={getShowFailureModal}
          // onHide={() => handleViewFileHide()}
          onHide={handleViewFileHide}
          // failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />
         <FileViewerModal
                show={getShowFileViewModal}
                onHide={handleViewFileHide}
                fileid={getFileViewData}
              />

        {/* </main> */}

        <form className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                // onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
              >
                Save
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default ProductMatrixAddModal;
